module.exports = __webpack_public_path__ + "img/ipad-mobile_jp.532ae72.jpg";